const  menu =  [
        {
            menu_name: "Dashboard",
            icon: "mdi-monitor-dashboard",
            link: "/system/dashboard",
        },
        {
            menu_name: "Cadastro",
            icon: "mdi-database-check",
            items: [
                {
                    title: "Obras",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/register/construction",
                },
                {
                    title: "Etapas",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/register/stage",
                },
                {
                    title:"Composições",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/register/composition_group",
                },
                {
                    title: "Insumos",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/register/input_group",
                },
                {
                    title: "Serviços",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/register/service_group",
                },
                {
                    title: "Encargos Socias",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/register/social_charges",
                },
                {
                    title: "Encargos Complementares",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/register/additional_charges",
                },
            ],
        },
        {
            menu_name: "Orçamento",
            icon: "mdi-cash-multiple",
            items: [
                {
                    title: "Custos",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/budget/cost",
                },
                // {
                //   title: "Orçamento",
                //   icon: "mdi-checkbox-blank-circle-outline",
                //   link: "/system/budget/budget",
                // },
                // {
                //   title: "Formação de Preço",
                //   icon: "mdi-checkbox-blank-circle-outline",
                //   link: "/system/budget/forming_price_data",
                // },
                {
                    title: "Formação de Preço",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/budget/forming_price",
                },
                {
                    title: "Cronograma Físico",
                    icon:  "mdi-checkbox-blank-circle-outline",
                    link:  "/system/budget/physical_progress/physical_schedule",
                },
                {
                    title: "Cronograma Financeiro",
                    icon:  "mdi-checkbox-blank-circle-outline",
                    link:  "/system/budget/financial_schedule",
                },
            ],
        },
        {
            menu_name: "Medições",
            icon: "mdi-gauge",
            items: [
                {
                    title: "Empreiteiro",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/physical_progress/contractor",
                },
                {
                    title: "Ordens de Serviço",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/physical_progress/order_service",
                },
                {
                    title: "Avanço Físico",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/physical_progress/physical_progress",
                },

                {
                    title: "Medições",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/physical_progress/metering",
                },
                {
                    title: "Medições MOP",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/physical_progress/metering_mop",
                },

            ],
        },
        {
            menu_name: "Controle de Custos",
            icon: "mdi-chart-arc",
            items: [
                {
                    title: "Controle de Insumo",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/controle_de_insumos/controle_de_insumos",
                },
                {
                    title: "Despesas Pagas",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/controle_de_insumos/expenses_paid",
                },
                {
                    title: "Cronograma Físico",
                    icon:  "mdi-checkbox-blank-circle-outline",
                    link:  "/system/physical_progress/physical_schedule",
                },

                {
                    title: "Cronograma Financeiro",
                    icon:  "mdi-checkbox-blank-circle-outline",
                    link:  "/system/physical_progress/financial_schedule",
                },
                {
                    title: "Planilha de Indexação",
                    icon:  "mdi-checkbox-blank-circle-outline",
                    link:  "/system/controle_de_insumos/indexing_spreadsheet",
                },


            ],
        },

        {
            menu_name: "Relatórios",
            icon: "mdi-chart-areaspline",
            items: [
                {
                    title: "Etapas",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/report/stage",
                },
                {
                    title: "Composições",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/report/composition",
                },
                {
                    title: "Insumos",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/report/input",
                },

            ],
        },
        {
            menu_name: "Sistema",
            icon: "mdi-cog",
            items: [
                {
                    title: "Perfis",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/system/role",
                },
                {
                    title: "Configuracão",
                    icon: "mdi-checkbox-blank-circle-outline",
                    link: "/system/system/configuration",
                },
            ],
        },
    ]

export default menu
